module.exports = __webpack_public_path__ + "img/google-authenticator.d93518cc.png";